// extracted by mini-css-extract-plugin
export default {"normalRange":"GraphNormalRange_normalRange__omDBI"};